import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createImage(
  parentId: string,
  masterBlockId?: MasterBlockId,
): ImageInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Image, parentId, masterBlockId),
    type: EntityTypeEnum.Image,
    alignSelf: 'center',
  }
}
